import {
  Flexbox, Form, PageHeader, Styles,
} from '@/components'
import usePageTitle from '@/hooks/usePageTitle'
import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

function Account({ title }) {
  usePageTitle({ title })

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Minha conta"
        icon="fas fa-user-cog"
        subtitle="Aqui você gerencia informações sobre a conta do parceiro/prefeitura"
      />
      <Flexbox.Columns>
        <Flexbox.Column className="col-8 col-sm-12">
          <Form.Group>
            <div className="bg-gray s-rounded p-1 mb-2">
              <Flexbox.Columns>
                <Flexbox.Column>
                  <div className="p-1">
                    <div>
                      <i className="fas fa-envelope" />
                      <b className="pl-2">Alterar e-mail</b>
                    </div>
                  </div>
                </Flexbox.Column>
                <Flexbox.Column className="col-auto">
                  <div className="p-1">
                    <Link to="/app/settings/account/change-email">
                      <i className="fas fa-arrow-right" />
                    </Link>
                  </div>
                </Flexbox.Column>
              </Flexbox.Columns>
            </div>
          </Form.Group>
        </Flexbox.Column>
        <Flexbox.Column className="col-8 col-sm-12">
          <Form.Group>
            <div className="bg-gray s-rounded p-1 mb-2">
              <Flexbox.Columns>
                <Flexbox.Column>
                  <div className="p-1">
                    <div>
                      <i className="fas fa-key" />
                      <b className="pl-2">Alterar senha</b>
                    </div>
                  </div>
                </Flexbox.Column>
                <Flexbox.Column className="col-auto">
                  <div className="p-1">
                    <Link to="/app/settings/account/reset-password">
                      <i className="fas fa-arrow-right" />
                    </Link>
                  </div>
                </Flexbox.Column>
              </Flexbox.Columns>
            </div>
          </Form.Group>
        </Flexbox.Column>
      </Flexbox.Columns>
    </Styles.Container>
  )
}

Account.propTypes = {
  title: PropTypes.string.isRequired,
}

export default Account
